// The signed-in user object from useAuth() — the login response and
// /api/v1/auth/user/ (dj-rest-auth) — carries `pk`, NOT `id`. Reading `user.id`
// silently yields undefined (RCA 2026-10-19: last-practice memory, FCM device
// de-dupe, task comment ownership and "your next tasks" all broke this way).
// Use userKeyOf(user) whenever you need the signed-in user's id.
export const userKeyOf = (user) => (user?.pk ?? user?.id ?? null);
